import CreationTabs from './creation-tabs';

export default CreationTabs;

